import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';
import { CaseRepository, Plan } from '../core';
import { BaseService } from './base.service';
import { UserService } from './user.service';


/**
* This service handles the case data.
*/
@Injectable({ providedIn: 'root' })
export class CaseService extends BaseService {

	private readonly userSrv = inject(UserService);
	private readonly caseRepo = inject(CaseRepository);

	private readonly _currentCase = new BehaviorSubject<Plan | null>(null);
	private readonly _isReadOnly = new BehaviorSubject<boolean | null>(null);


	/**
	* Get current case.
	*/
	getCurrentCase(): Observable<Plan> {
		return this._currentCase.asObservable().pipe(first(_case => !!_case));
	}

	/**
	* Get case by id.
	* @param {string} id Case GUID.
	*/
	getCase(id: string): Observable<Plan> {
		return this.caseRepo.getCase(id).pipe(
			map(response => this.handleApiResponse(response)),
			tap(c => this._currentCase.next(c))
		);
	}

	/**
	* Check if is read-only case.
	*/
	isReadOnly(): Observable<boolean | null> {
		if (this._isReadOnly.value === null) {
			return combineLatest([this.getCurrentCase(), this.userSrv.getCurrentUser()]).pipe(
				filter(([_case, _user]) => !!_case && !!_user),
				first(),
				map(([_case, _user]) => _case.userGuid !== _user.id),
				tap(res => this._isReadOnly.next(res))
			);
		}
		return this._isReadOnly.asObservable();
	}

}
